import React, { useState, useEffect } from "react";
import axiosInstance from "../../../ReusableComponents/Axios";
import CopyRight from "../../Reusablecomponents/Copyright";
import InternetChecking from "../../Reusablecomponents/Network";
import Loading from "../../Reusablecomponents/Loading";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { format } from "date-fns";
const ASDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
   const AssessmentData = JSON.parse(localStorage.getItem("AssessmentData"));
  const [TestDetails, SeTestDetails] = useState();
  const [Load, SetLoad] = useState(false);
  const [AssessmenTesTypes, SetAssessmenTesTypes] = useState([]);
  const GetTestDetails = async () => {
    SetLoad((prev) => !prev);
    SeTestDetails();
    if (USYear?.display === "2024-25" || USYear?.display === "2025-26") {
      SetAssessmenTesTypes([
        { title: "SODHANA", type: 1 },
        { title: "SADHANA", type: 2 },
        { title: "SAMAGRA", type: 3 }
      ]);
    } else {
      SetAssessmenTesTypes([
        { title: "SODHANA", type: 1 },
        { title: "SAMAGRA", type: 3 }
      ]);
    }
    try {
      const response = await axiosInstance.get(
        `/Assessment/GetStudentQuestionAnswerSheet?UserId=${items?.userId}&Year=${USYear?.value}`,
      );
      SeTestDetails(response.data);
      SetLoad((prev) => !prev);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (USYear?.value) {
      GetTestDetails();
    }
  }, [USYear]);

  const VASNavigate = (Row, SSubject) => {
    if (Row.isStudentResult) {
     
      navigate(
        `${location.state?.Page === "LOPR"
          ? Row.assessmentType === 3
            ? "/Samagra/LoPerformance"
            : "/LoPerformanceReport"
          : "/ViewAnswerSheetDetails/ViewAnswerSheet"
        }`,
        {
          state: {
            CCID: Row?.contestCreationID,
            TType: Row?.assessmentType,
            Grade: items?.grade,
            Subjects: Row?.subjects,
            Date: Dateformat(Row.examAvailabilityStartDate.split(" ")[0]),
            ATType: Row?.testType,
            ATypeName: Row?.assessmentTypeNo,
            SSubject: Row?.testType === "single" ? SSubject.trim() : "",
          },
        },
      );
    }
  };
  const QPNavigation = (Row) => {
    if (Row.viewQuestionPaper) {
      navigate("/ViewAnswerSheetDetails/Question Paper", {
        state: {
          CCID: Row?.contestCreationID,
          Grade: items?.grade,
          AType: Row?.assessmentType,
          date: Dateformat(Row.examAvailabilityStartDate.split(" ")[0]),
          UserId:
            items?.instituteId === 5 && Row?.paperSets === "multiple"
              ? items?.userId
              : 0,
          LanguID: items?.mediumId,
          Subjects: Row?.subjects,
          ATName: Row?.assessmentTypeNo,
          Duration: Row?.duration,
        },
      });
    }
  };
  const ReportCardNavigation = (Row) => {
    if(Row?.assessmentType === 3 ){
 navigate("/ReportCard/Samagara", {
        state: {
          CCID: Row?.contestCreationID,
          AType: Row?.assessmentType,
          Date: Dateformat(Row.examAvailabilityStartDate.split(" ")[0]),
          AssTypeNo: Row?.assessmentTypeNo,
        },
      });
    }
    else{
      navigate("/ReportCard", {
        state: {
          CCID: Row?.contestCreationID,
          AType: Row?.assessmentType,
          Date: Dateformat(Row.examAvailabilityStartDate.split(" ")[0]),
        },
      });
    }

  };
  const Dateformat = (e) => {
    const [day, month, year] = e.split("-");
    const date = new Date(`${year}-${month}-${day}`);
    return format(date, "dd MMM yyyy");
  };

  const renderRows = (type) => {
    const filtered = TestDetails?.filter(
      (item) => item.assessmentType === type,
    );

    if (!filtered?.length) {
      return (
        <tr>
          <td colSpan={6} className="text-center">
            ** No data available **
          </td>
        </tr>
      );
    }

    return filtered.map((item) => {
      const subjects =
        item?.testType === "single"
          ? item.subjects.split(",").reverse()
          : ["ALL"];

      const dates =
        item?.testType === "single"
          ? item.examStartDates.split(",").reverse()
          : [Dateformat(item.examAvailabilityStartDate?.split(" ")[0])];

      return subjects.map((subject, index) => (
        <tr key={`${item.assessmentTypeNo}-${index}`}>
          <td>{index === 0 ? item?.assessmentTypeNo.split(" ")[1] : ""}</td>

          <td>{dates[index]}</td>

          <td>{subject}</td>

          {/* Answer Sheet */}
          {location.state?.Page === "LOPR" && index === 0 && (
            <td
              rowSpan={item?.testType === "single" && subjects?.length}
              className={ (item.isStudentResult && (item?.contestCreationID != AssessmentData?.contestCreationID || AssessmentData?.isSubmitted) )? "LinkStyles" : ""}
              onClick={() =>  (item.isStudentResult && (item?.contestCreationID != AssessmentData?.contestCreationID || AssessmentData?.isSubmitted) ) && VASNavigate(item, subject)}
            >
              {/* {item.isStudentResult ? <>View</> : "Absent"}  */}
              {/* {(item?.contestCreationID == AssessmentData?.contestCreationID && !item.isStudentResult) ? "-" : item.isStudentResult ? <>View</> : "Absent"} */}
              {(item?.contestCreationID == AssessmentData?.contestCreationID && !AssessmentData?.isSubmitted) ? "-" : item.isStudentResult ? <>View</> : "Absent"}
            </td>
          )}
          {location.state?.Page !== "LOPR" && (
            <td
              className={(item.isStudentResult && (item?.contestCreationID != AssessmentData?.contestCreationID || AssessmentData?.isSubmitted) )  ? "LinkStyles" : ""}
              onClick={() => (item.isStudentResult && (item?.contestCreationID != AssessmentData?.contestCreationID || AssessmentData?.isSubmitted) ) && VASNavigate(item, subject)}
            >
              {/* {item.isStudentResult ? "View" : "Absent"} */}
              {(item?.contestCreationID == AssessmentData?.contestCreationID && !AssessmentData?.isSubmitted) ? "-" : item.isStudentResult ? <>View</> : "Absent"}
            </td>
          )}

          {/* Question Paper */}
          {index === 0 && (
            <td
              rowSpan={item?.testType === "single" && subjects?.length}
              className={(item.viewQuestionPaper && (item?.contestCreationID != AssessmentData?.contestCreationID || AssessmentData?.isSubmitted)) ? "LinkStyles" : ""}
              onClick={() => item.viewQuestionPaper && (item?.contestCreationID != AssessmentData?.contestCreationID || AssessmentData?.isSubmitted) && QPNavigation(item)}
            >
              {(item?.contestCreationID == AssessmentData?.contestCreationID && !AssessmentData?.isSubmitted) ? "-" : item.viewQuestionPaper ? <> View & Download</> : "View & Download"}

             
            </td>
          )}

          {/* Report Card */}
          {index === 0 && (
            <td
              rowSpan={item?.testType === "single" && subjects?.length}
              // && item.assessmentType !== 3
              className={
                item.isStudentResult  && (item?.contestCreationID != AssessmentData?.contestCreationID || AssessmentData?.isSubmitted)
                  ? "LinkStyles"
                  : ""
              }
              // && item.assessmentType !== 3
              onClick={() => item.isStudentResult  && (item?.contestCreationID != AssessmentData?.contestCreationID || AssessmentData?.isSubmitted) && ReportCardNavigation(item)}
            >
              {
              // item.assessmentType === 3
              //   ? "-"
              //   : 
                (item?.contestCreationID == AssessmentData?.contestCreationID && !AssessmentData?.isSubmitted) ? "-" : item.isStudentResult ? "View" : "Absent"}
            </td>
          )}
        </tr>
      ));
    });
  };
  return (
    <>
      <div
        className="VASheet Instructions-pages"
        style={{ position: "relative" }}
      >
        <InternetChecking />

        <h5 className="Vtitle">
          {location.state?.Page === "LOPR"
            ? "Lo Performance Reports"
            : "Download Question paper and answer sheets for Assessments"}
        </h5>
        <div className=" STudenTable mt-2">
          <table className="Data-Table" style={{ tableLayout: "fixed" }}>
            <thead>
              <tr>
                <th>Assessment No</th>
                <th>Date</th>
                <th>Subject(s)</th>
                <th>
                  {location.state?.Page === "LOPR"
                    ? "LO Performance Report"
                    : "Answer Sheet"}
                </th>
                <th>Question Paper</th>
                <th>Report Card</th>
              </tr>
            </thead>
          </table>
        </div>

        {TestDetails  && AssessmenTesTypes?.map(({ title, type }) => (
          <div className="Card STudenTable mt-2">
            <div className="SubHeading mt-1 mb-2">{title}</div>
            <table className="Data-Table" style={{ tableLayout: "fixed" }}>
              <tbody>{renderRows(type)}</tbody>
            </table>
          </div>
        ))}
        <div style={{ position: "inherit", bottom: "-150px" }}>
          <CopyRight />
        </div>
        {Load && <Loading />}
      </div>
    </>
  );
};
export default ASDetails;
